export default "__VITE_ASSET__DX47WrGG__"